import { StackRouter } from "@react-navigation/native";

var CustomStackRouter = function(options) {
	var router = StackRouter(options);
	var og = router.getStateForAction.bind(router);
	router.getStateForAction = function(state, action, options2) {
		return og(state, action, options2);
	};
	return router;
};

export { CustomStackRouter };